export class KeyControl {
    kcParent : string;
    kcCompany : string;
    kcDivision : string;
    kcBrand : string;
    kcDistributionChannel : string;
}
